module.exports = __webpack_public_path__ + "static/media/ally-II-ups-image@2x.006ae331.png";